import React, { ReactElement } from 'react';
import { ShippingMethodContract } from '../../../types/ShippingMethods';
import UtilityService from '../../../services/UtilityService';
import ShippingMethodDisplay from '../ShippingMethodDisplay';
import SectionSummary, { SectionSummaryGroupPosition } from '../SectionSummary';

export type DeliverySummaryProps = {
  currencySymbol: string;
  shippingMethod: ShippingMethodContract;
  groupPosition?: SectionSummaryGroupPosition;
  onEditDeliveryClicked?: () => void;
};

const DeliverySummary: React.FC<DeliverySummaryProps> = ({
  currencySymbol,
  shippingMethod,
  groupPosition,
  onEditDeliveryClicked,
}: DeliverySummaryProps) => {
  const shippingMethodDisplayElm = (): ReactElement => {
    return (
      <ShippingMethodDisplay
        name={shippingMethod.name}
        price={UtilityService.formatAmount(
          shippingMethod.price,
          currencySymbol
        )}
      />
    );
  };

  return (
    <SectionSummary
      title="Delivery"
      content={shippingMethodDisplayElm()}
      displayActionButton
      actionButtonText="Edit"
      onActionButtonClicked={onEditDeliveryClicked}
      groupPosition={groupPosition}
      toolTipKey="DeliverySummaryKey"
      linkButtonDataTestId="LinkButton-input-Delivery-Summary"
    />
  );
};

export default DeliverySummary;
